import React from 'react';
import Lang from "../../Lang/Lang";

function SpecialDealList (props) {
  const { promotions } = props;

  const monthsData = JSON.parse(Lang.getMessage('months'));

  function formatDate(activeTo, monthsData) {
    if (activeTo) {
      const [dateStr, timeStr] = activeTo.split(' ');
      const [day, month, year] = dateStr.split('.');

      const formattedMonth = monthsData[month] || '';

      return ` ${day} ${formattedMonth} ${year ? year : ''}`
    }
  }

  return (
    <ul className="grid grid-cols-4 grid-rows-2 gap-5 w-full h-full" >
      {Array.isArray(promotions) &&
        promotions.map((promotion, index) => (
          <li key={index} className="flex flex-col">
            <a href={promotion.url} className="flex max-h-[calc(100%-70px)]" rel="noopener noreferrer">
              <img src={promotion.previewPictureSrc} alt={promotion.title} className="w-full h-auto rounded object-cover" />
            </a>
            <a href={promotion.url} rel="noopener noreferrer"
              className=" text-[14px] leading-[20px] font-normal mt-2 webkit-box line-clamp-1 min-h-[21px] h-[21px] overflow-hidden hover:underline hover:underline-offset-2 hover:decoration-blue-primary hover:text-blue-primary">
              {promotion.title}
            </a>
            <p className={`text-gray-80 text-[13px] leading-[17px] m-0 pt-2 ${promotion.isFuture ? 'text-[#F49423]' : ''}`}>
              {Lang.getMessage(promotion.isFuture ? 'startFrom' : 'before')} {formatDate(promotion.isFuture ? promotion.activeFrom : promotion.activeTo, monthsData)}
            </p>
          </li>
        ))}
    </ul>
  );
}

export default SpecialDealList